import { ref, computed } from 'vue';

const UsersUtils = (store) => {
    const user = computed(() => store.state.user.user)

    const myUsers = computed(() => store.state.users.users)
    
    const myOwners = computed(() => { // only MY owners
        if (!user) { return [] }
        const tempA = store.state.licenses.licenses.filter((license) => license.admin.id !== user.value.id) // ONLY PRODUCTS WHERE I AM NOT THE OWNER
        const tempB = [].concat(...tempA.map((license) => license.admin)) // RETRIEVE ALL THE OWNERS TOGETHER
        const tempC = tempB.filter((value, index, self) => { // REMOVE DUPLICATED
            return self.findIndex(obj =>
                obj.id === value.id
            ) === index;
        });
        const res = tempC.sort((a,b) => { // SORT IN THE ALPHABETICAL ORDER
            const nameA = a.first_name.toLowerCase()
            const nameB = b.first_name.toLowerCase()
            if (nameA < nameB) { return -1 }
            else if (nameA > nameB) { return 1 }
            else { return 0 }
        })
        return res
    })
    
    const myDelegates = computed(() => { // only MY delegates
        if (!user) { return [] }
        const tempA = store.state.licenses.licenses.filter((license) => license.admin.id === user.value.id) // ONLY PRODUCTS WHERE I AM OWNER
        const tempB = [].concat(...tempA.map((license) => license.delegates)) // RETRIEVE ALL THE DELEGATES TOGETHER
        const tempC = tempB.filter((value, index, self) => { // REMOVE DUPLICATED
            return self.findIndex(obj =>
                obj.id === value.id
            ) === index;
        });
        const res = tempC.sort((a,b) => { // SORT IN THE ALPHABETICAL ORDER
            const nameA = a.first_name.toLowerCase()
            const nameB = b.first_name.toLowerCase()
            if (nameA < nameB) { return -1 }
            else if (nameA > nameB) { return 1 }
            else { return 0 }
        })
        return res
    })

    const allUsers = computed(() => {
        const tempA = [].concat(...store.state.licenses.licenses.map((license) => license.admin)) // RETRIEVE ALL THE OWNERS TOGETHER (for ALL licenses)
        const tempB = [].concat(...store.state.licenses.licenses.map((license) => license.delegates)) // RETRIEVE ALL THE DELEGATES TOGETHER (for ALL licenses)
        const tempC = [...tempA, ...tempB, ...myUsers.value].filter((u) => u.id !== user.value.id) // MERGE TOGETHER AND FORGET ME FROM THE LIST
        const tempD = tempC.filter((value, index, self) => { // REMOVE DUPLICATES
            return self.findIndex(obj =>
                obj.id === value.id
            ) === index;
        });
        const res = tempD.sort((a,b) => { // SORT IN THE ALPHABETICAL ORDER
            const nameA = a.first_name.toLowerCase()
            const nameB = b.first_name.toLowerCase()
            if (nameA < nameB) { return -1 }
            else if (nameA > nameB) { return 1 }
            else { return 0 }
        })
        return res
    })

    const allOtherUsers = computed(() => {
        allUsers.value.filter((u) => !(myUsers.value.some((u1) => u1.id === u.id) || myOwners.value.some((u1) => u1.id == u.id) || myDelegates.value.some((u1) => u1.id == u.id)))
    })
    
    const myIndirectlyLinkedUsers = computed(() => {
        if (!user) { return [] }
        const tempA = store.state.licenses.licenses.filter((license) => license.admin.id !== user.value.id) // ONLY PRODUCTS WHERE I AM NOT OWNER
        const tempB = [].concat(...tempA.map((license) => license.delegates)) // RETRIEVE ALL THE DELEGATES TOGETHER
        const tempC = tempB.filter((value, index, self) => { // REMOVE DUPLICATED AND ME
            const condNotMe = value.id !== store.state.user.user.id
            const condNoDuplicates = self.findIndex(obj =>
                obj.id === value.id
            ) === index;
            return condNotMe && condNoDuplicates
        });
        const res = tempC.sort((a,b) => { // SORT IN THE ALPHABETICAL ORDER
            const nameA = a.first_name.toLowerCase()
            const nameB = b.first_name.toLowerCase()
            if (nameA < nameB) { return -1 }
            else if (nameA > nameB) { return 1 }
            else { return 0 }
        })
        return res
    })

    return {
        allUsers, // ALL
        myUsers, // My users, i.e. users I added and I can set as delegates
        myOwners, // My owners, i.e. users that are owner of licenses I am delegate to
        myDelegates, // My delegates, i.e. users that are currently set as one of my delegates for at least a license
        allOtherUsers, // All users that are linked to me but not directly, i.e. not in myOwners AND not in myDelegates
        myIndirectlyLinkedUsers // All the delegates in licenses where I am NOT the owner (and not me in that list indeed)
    };
}

export default UsersUtils